import type { RiaSourceContext } from '@/analytics/utils/ria-source-analytics'
import { buildCaselawStandaloneViewerURL } from '@/standalone-reference-viewer/caselaw/utils/build-caselaw-viewer-url'
import { buildLrrStandaloneViewerURL } from '@/standalone-reference-viewer/lrr/utils/build-lrr-viewer-url'
import { buildLegacyFileViewerUrl } from '@/standalone-reference-viewer/legacy-file/utils/build-legacy-file-viewer-url'
import { buildWritingSampleStandaloneViewerURL } from '@/standalone-reference-viewer/writing-sample/utils/build-writing-sample-viewer-url'
import { matterPaths } from '@/routing/paths'
import { ViewerDocumentKind, ViewerOpenContextKind, type ContentViewerSession } from '@/content-viewer/store/schemas'

export function resolveStandaloneViewerUrlFromSession(
  session: ContentViewerSession | null | undefined,
  context: RiaSourceContext | undefined
): string | undefined {
  if (!session || session.context.kind !== ViewerOpenContextKind.CHAT_CITATION) return undefined

  switch (session.document.kind) {
    case ViewerDocumentKind.CASELAW:
      return (
        buildCaselawStandaloneViewerURL(
          { s3_dir: session.document.s3Dir, s3_path: session.document.s3Path },
          {
            conversationId: session.context.conversationId,
            messageId: session.context.turnId,
            matterId: context?.matterId,
          }
        ) || undefined
      )
    case ViewerDocumentKind.LRR:
      return buildLrrStandaloneViewerURL({ s3_path: session.document.s3Path }, { matterId: context?.matterId }) ?? undefined
    case ViewerDocumentKind.USER_FILE:
      if (!context?.matterId) return undefined
      return matterPaths.referenceViewer.userFile(context.matterId, encodeURIComponent(session.context.agentReferenceId))
    case ViewerDocumentKind.LEGACY_FILE:
      return buildLegacyFileViewerUrl(session.document.id, context?.matterId ?? null) ?? undefined
    case ViewerDocumentKind.WRITING_SAMPLE:
      return (
        buildWritingSampleStandaloneViewerURL(session.document.referenceId, {
          matterId: context?.matterId,
        }) ?? undefined
      )
    case ViewerDocumentKind.ARTIFACT:
      return undefined
  }
}
